import login from './login';

export default {
  language: 'id-ID',
  country: 'id',
  name: 'Bahasa Indonesia',
  embeddedLocale: login,
};
